export default "__VITE_ASSET__1b60ad52__"